import * as signalR from "@aspnet/signalr";

import { axiosApp } from "../../../utils/appAxios";
import { getUpdatedList, getQueryParamValue } from "../../../utils/common";

const moduleTestSignalR = {
  state: () => ({
    notification: {
      count: 0
    },
    botStatus: {},
    botList: [],
    botLogId: null,
    logList: []
  }),
  mutations: {
    setNotifyCount(state, count) {
      state.notification.count = count;
    },
    setBotStatus(state, { slug, app, site, total, date }) {
      state.botStatus = {
        slug,
        app,
        site,
        total,
        date
      };
    },
    setBotList(state, data) {
      state.botList = data;
    },
    setBotLogId(state, botId) {
      state.botLogId = botId;
    },
    setLogList(state, data) {
      state.logList.unshift(data);
      if (state.logList.length > 30) state.logList.pop();
    },
    clearLogList(state, data) {
      state.logList = [];
    },
    clearBotList(state, data) {
      state.botList = [];
    }
  },
  actions: {
    initSignalR({ commit, dispatch, state }, payload) {
      const baseURL = process.env.VUE_APP_TEST_SIGNALR;
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseURL}/ServiceHub`)
        .build();

      /* Total Watch Request */
      connection.on(
        "totalWatchRequest",
        (slug, app, site, total, date, sid) => {
          if (sid === "prolivehit") {
            const list = state.botList;
            const updatedList = getUpdatedList({
              list,
              date,
              total,
              app,
              site,
              slug
            });

            const payload = { slug, app, site, total, date };

            commit("setBotStatus", payload);
            commit("setBotList", updatedList);
          }
        }
      );

      /* Send Message */
      connection.on(
        "GetMessage",
        (app, message, date, customer, id, error, sid) => {
          if (sid === "prolivehit") {
            const data = {
              app,
              context: message,
              date,
              customer,
              bonus: id
            };

            const botId = Number(state.botLogId);
            const upApp = Number(app);

            if (botId === upApp) {
              commit("setLogList", data);
            }
          }
        }
      );

      connection
        .start({ jsonp: true })
        .catch(error => console.log("signalR connection error: ", error));
    },
    getBotListService({ commit }) {
      axiosApp.get(`/AppProcess/ListAppProcess`).then(response => {
        commit("setBotList", response.data);
      });
    },
    getLogListService({ commit }, id) {
      axiosApp.get("AppLog/ListAppLogs/" + id).then(response => {});
    }
  },
  getters: {
    getNotifyCount(state) {
      return state.notification.count;
    },
    getBotStatus(state) {
      return state.botStatus;
    },
    getBotList(state) {
      return state.botList;
    },
    getLogList(state) {
      return state.logList;
    }
  }
};

export default moduleTestSignalR;



// WEBPACK FOOTER //
// ./src/store/Modules/signalR/index.js